import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _map from 'lodash/map';
import _fromPairs from 'lodash/fromPairs';
import _pickBy from 'lodash/pickBy';

var serialize = function serialize(items) {
  return _map(items, function (value, key) {
    return key + "=" + value;
  }).join('&');
};

var deserialize = function deserialize(string) {
  var _context;

  return _fromPairs(_mapInstanceProperty(_context = decodeURI(string).split('&')).call(_context, function (s) {
    return s.split('=');
  }));
};

var clean = function clean(items) {
  return _pickBy(items, function (i) {
    return i !== undefined && i !== null;
  });
};

export default {
  serialize: serialize,
  deserialize: deserialize,
  clean: clean
};
//# sourceMappingURL=query-string.js.map